import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabs-pill',
  templateUrl: './tabs-pill.component.html',
})
export class TabsPillComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
